export const root: string = "/admin/";

// App e API condividono lo stesso host: l'API è esposta su `/api/` (in dev tramite
// il dev-proxy CRA in src/setupProxy.js, in prod tramite il proxy nginx).
export const baseURL: string = window.location.origin + "/";
export const apiURL: string = baseURL + "api/";
export const clients = {
    "1": {
        id: "06310cfc-41f9-4e02-ad9a-524fa5e928bd",
        secret: "rxDgMbX3NsIs0CpwVSx7e0ye",
        orgKey: "4303458090641444613",
    },
    "2": {
        id: "e5a0c573-fe80-4cb6-9a9c-ada771314209",
        secret: "QtxtGqfmtuWNuYuitWzl5tZy",
        orgKey: "4496277271923801612",
    },
    "3": {
        id: "fb415b44-d664-4de5-9dc1-982ecf4a247e",
        secret: "SME8nayNIC7fd39RiAepqOiK",
        orgKey: "2996988709996557061",
    },
    "4": {
        id: "b057c5be-55d7-4af3-b69f-53fda795672f",
        secret: "detSh0tRKdeWVYmEZrx82dSj",
        orgKey: "1751148599404291675",
    },
    // "ThePlan": {
    //     id:     'ae087ebc-e245-4be1-9f3b-5b99a865b6e9',
    //     secret: '7wJKBXz4ez1cBa1VavTkHyjx',
    //     orgKey: '5876755920994712157',
    // },
};

export const baseWebinarURLV1: string = "https://api.getgo.com/G2W/rest/";
export const baseWebinarURLV2: string = "https://api.getgo.com/G2W/rest/v2/";

export const userXls2Json: string = "api";
export const passwordXls2Json: string = "password";

export const jwtKey: string = "tempkey123";
export const privacyToken: string =
    "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJwcml2YWN5Lm1hZ2dpb2xpY2xvdWQuaXQiLCJhdWQiOjEsImlhdCI6MTY0NjYzOTQ3NiwibmJmIjoxNjQ2NjM5NDc2LCJleHAiOjE5NjE5OTk0NzYsImRhdGEiOnsiaWQiOjg0LCJzaXRlX2lkIjoxMTJ9fQ.pd13lxw6bSrUEpOokiBk4G26PbCSBI2yxq8IZdJ-oZI";

export const emailPayload = (email: string, webinarID: string, webinarTitle: string, webinarDatetime: string) => {
    return {
        to: email, // email utente
        from: "no-reply-siti-web@maggiolieditore.it", //email no replay sito
        fromName: "Registrazione Webinar", //nome sito
        replyTo: "no-reply-siti-web@maggiolieditore.it", //email no replay
        subject: `Registrazione evento Webinar ${webinarTitle}`,
        message: `<strong style="font-size: x-large">Registrazione evento Webinar<br/> ${webinarTitle}</strong><br/>
        <strong style="font-size: large">${convertDate(webinarDatetime)}</strong><br/><br/>
            Grazie per aver scelto di partecipare al nostro webinar.<br/>
            Per finalizzare l'iscrizione vai a  <a href="${baseURL}register/${webinarID}">questa pagina</a> e compila il form.<br/><br/>
            Gruppo Maggioli<br/>
            Via del Carpino, 8 Santarcangelo di Romagna (RN)`,
        categories: ["no-reply-sitiweb@maggiolicloud.it", "registrazione_webinar", "iscrizione"],
    };
};

const convertDate = (datetime: string) => {
    const prova = new Date(datetime);
    const date = `${prova.getDate()}/${prova.getMonth() + 1}/${prova.getFullYear()}`;
    const minutes = prova.getMinutes().toString().length === 1 ? `0${prova.getMinutes()}` : prova.getMinutes();
    const time = `${prova.getHours()}:${minutes}`;
    return `${date}, ore ${time}`;
};

const pad2 = (n: number) => n.toString().padStart(2, "0");

const parseRawDate = (rawDate: string) => new Date(rawDate.replace(".", ":").split(" ").slice(0, 4).join(" "));

export const getConsensoDate = (rawDate: string, divided: boolean = false) => {
    const date = parseRawDate(rawDate);
    const year = date.getFullYear();
    const month = pad2(date.getMonth() + 1);
    const day = pad2(date.getDate());

    return divided ? `${day}-${month}-${year}` : `${year}${month}${day}`;
};

export const getTime = (rawDate: string, divided: boolean = false) => {
    const date = parseRawDate(rawDate);
    const hours = pad2(date.getHours());
    const minutes = pad2(date.getMinutes());

    return divided ? `${hours}:${minutes}` : `${hours}${minutes}00`;
};

export const validateEmail = (email: string) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
};
